/*
	Custom Poster44 JS
*/


$(function(){

  var descHeight = $('#poster44-collection-desc-inner').height();
  //console.log(descHeight);
  
  if(descHeight < 150){
    
  	$('#poster44-collection-desc').addClass('poster44-collection-desc-active');
    $('#poster44-collection-desc-button').hide();
    $('#poster44-collection-desc-gradient').hide();
    
  }else{

    $('#poster44-collection-desc-button').on('click', function(e){
      e.preventDefault();

      $('#poster44-collection-desc').toggleClass('poster44-collection-desc-active');

      $('#poster44-collection-desc-button').fadeOut(500);
      $('#poster44-collection-desc-gradient').fadeOut(500);
    });
    
  }


  // apply random
  $('.poster44-home-feature-products-wrapper-1 .grid-uniform.product-grid .grid__item').pick(4);
  $('.poster44-home-feature-products-wrapper-2 .grid-uniform.product-grid .grid__item').pick(12);
  $('.poster44-home-feature-products-wrapper-3 .grid-uniform.product-grid .grid__item').pick(24);
  $('.poster44-home-feature-products-wrapper-4 .grid-uniform.product-grid .grid__item').pick(8);
  $('.poster44-home-feature-products-wrapper-5 .grid-uniform.product-grid .grid__item').pick(8);
  $('.poster44-home-feature-products-wrapper-6 .grid-uniform.product-grid .grid__item').pick(4);

});

